import React from 'react';
import CoachingReviewListeningAssistant from 'components/calls/components/sidebar/listening-assistant/CoachingReviewListeningAssistant';
import CoachingPlanStore from 'stores/coaching/CoachingPlanStore';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import CoachingReviewStore from 'stores/coaching/CoachingReviewStore';
import CardReasonStore from 'stores/CardReasonStore';
import ScorecardStore from 'stores/ScorecardStore';
import {associateBy} from 'utils/associateBy';
import {List, Map} from 'immutable';
import InProgressReviewActions from 'actions/coaching/InProgressReviewActions';
import AuthStore from 'stores/AuthStore';
import InProgressReviewStore from 'stores/coaching/InProgressReviewStore';
import InProgressReview from 'records/InProgressReview';
import CoachingReviewFileUpload, {FileUploadId} from 'records/CoachingReviewFileUpload';
import connectToStores from 'alt-utils/lib/connectToStores';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {getNumericState} from 'utils/getQueryParam';

interface Props {
  location: RouterLocation;
  callId: FileUploadId;
}

@connectToStores
class CoachingReviewListeningAssistantContainer extends React.Component<
  Props & ReturnType<typeof CoachingReviewListeningAssistantContainer.getPropsFromStores>
> {
  static getStores() {
    return [
      AuthStore,
      CoachingPlanStore,
      CoachingReviewStore,
      InProgressReviewStore,
      CardReasonStore,
      ScorecardStore,
    ];
  }

  static getPropsFromStores({location}) {
    // Location state is set from CallLink component used in Coaching
    const planId = getNumericState(location, 'planId');
    const reviewId = getNumericState(location, 'reviewId');
    if (!planId || !reviewId) return {};

    const plan = CoachingPlanStore.getState().planMap.get(planId);

    const review = plan?.reviews?.find(r => r.id === reviewId);

    const reviewFileUploads = CoachingReviewStore.getState().reviewFileUploads.get(review?.id);

    const reviewTypeAnswers = CoachingReviewStore.getState().coachingReviewAnswers.get(
      review && review?.id,
      List()
    );

    const inProgressReview = InProgressReviewStore.getState().inProgressReviews.get(
      review?.id + ''
    );

    // @ts-ignore
    const reasonSchemes = CardReasonStore.getState().cardReasons;

    // @ts-ignore
    const scorecardStore = ScorecardStore.getState();
    const scorecards = scorecardStore.scorecards;
    const scoringSchemeMap = Map(
      scorecards.flatMap(s => s.questions.map(q => [q.id, s.scoringScheme]))
    );

    const questionMap = associateBy(scorecards.flatMap(s => s.questions) as List<any>, q => q.id);

    return {
      plan,
      reviewFileUploads,
      inProgressReview,
      reasonSchemes,
      scoringSchemeMap,
      questionMap,
      review,
      reviewTypeAnswers,
      reviewId,
    };
  }

  componentDidMount() {
    const {plan, review} = this.props;
    if (plan && review) {
      CoachingPlaylistActions.hide.defer();
    }
  }

  onChange = (updatedRfu: CoachingReviewFileUpload, inProgressReview: InProgressReview) => {
    const user = AuthStore.getState().user;

    const updateIndex = inProgressReview.reviewFileUploads!.findIndex(
      rfu => rfu?.id === updatedRfu.id
    );

    if (updateIndex === -1) {
      console.error('couldnt update the ongoing review!');
    }

    const updatedInProgress = inProgressReview.setIn(
      ['reviewFileUploads', updateIndex],
      updatedRfu
    );

    InProgressReviewActions.setInProgressReview(updatedInProgress, user);
  };

  render() {
    const {
      callId,
      plan,
      inProgressReview,
      reviewFileUploads,
      questionMap,
      scoringSchemeMap,
      reasonSchemes,
      review,
      reviewId,
      reviewTypeAnswers,
    } = this.props;
    const inProgressReviewFileUploads = inProgressReview?.reviewFileUploads;

    // use review fileuploads either from the in progress (localstorage) store or review alt store.
    const reviewFileUpload = (inProgressReviewFileUploads || reviewFileUploads)?.find(
      rfu => rfu.fileuploadId === callId
    );

    const sessionUser = AuthStore.getState().user || undefined;

    if (!plan || !reviewFileUpload || !reviewId) return null;

    return (
      <CoachingReviewListeningAssistant
        plan={plan}
        reviewFileUpload={reviewFileUpload}
        reasonSchemes={reasonSchemes}
        scoringSchemeMap={scoringSchemeMap}
        questionMap={questionMap}
        onChange={rfu => this.onChange(rfu, inProgressReview!)}
        inProgress={!!inProgressReviewFileUploads}
        isPrepping={inProgressReview?.isPrepping ?? false}
        reviewId={reviewId}
        review={review}
        sessionUser={sessionUser}
        reviewFileUploads={reviewFileUploads}
        reviewTypeAnswers={reviewTypeAnswers}
      />
    );
  }
}

export default CoachingReviewListeningAssistantContainer as unknown as React.ComponentType<Props>;
